export const dayOptionLabel = {
    ONE_DAY: "1 Day",
    TWO_DAYS: "2 Days",
    THREE_DAYS: "3 Days",
    FOUR_DAYS: "4 Days",
    FIVE_DAYS: "5 Days",
    SIX_DAYS: "6 Days",
    SEVEN_DAYS: "7 Days",
    EIGHT_DAYS: "8 Days",
    NINE_DAYS: "9 Days",
    TEN_DAYS: "10 Days",
    TWO_WEEKS: "2 Weeks",
    THREE_WEEKS: "3 Weeks",
    FOUR_WEEKS: "4 Weeks",
};

export const dayOptionValue = {
    ONE_DAY: "1",
    TWO_DAYS: "2",
    THREE_DAYS: "3",
    FOUR_DAYS: "4",
    FIVE_DAYS: "5",
    SIX_DAYS: "6",
    SEVEN_DAYS: "7",
    EIGHT_DAYS: "8",
    NINE_DAYS: "9",
    TEN_DAYS: "10",
    TWO_WEEKS: "14",
    THREE_WEEKS: "21",
    FOUR_WEEKS: "28",
};

export const rentalType = {
    hourly: 'hourly',
    daily: 'daily',
    monthly: 'monthly',
    monthly_recurring: 'monthly-recurring'
}

export const GLOBAL_CONSTANTS = {
    UNITEDKINGDOM: 'United Kingdom'
}

export const ERROR_MESSAGES = {
    GENERIC_RETRY: "We're sorry, something went wrong. Please try again in a few moments.",
}